import { Icon } from '../../components/Icon';
import { LIVE_FILL } from './liveStyles';

/**
 * Painted above the page on every Live route and sticky while the page scrolls. The
 * message is structural (icon + the word LIVE + "real money"), never hue alone.
 */
export function LiveBanner() {
  return (
    <div
      role="status"
      data-live-banner
      className={`sticky top-0 z-20 flex items-center gap-2.5 px-4 py-2 text-[12.5px] ${LIVE_FILL}`}
    >
      <Icon name="alert" size={15} />
      <strong className="tracking-wide">LIVE — REAL MONEY</strong>
      <span className="hidden opacity-90 sm:inline">
        Orders placed here would go to a live brokerage account. Nothing routes an order until
        Milestone 3.
      </span>
    </div>
  );
}
